export default __webpack_public_path__ + "static/media/Emotion_Neutral.35cc5470.svg";